const prefix = '@@KANDY/LOGS/'

export const SET_LEVEL = prefix + 'SET_LEVEL'
export const LEVELS_CHANGE = prefix + 'LEVELS_CHANGE'

export const SET_HANDLER = prefix + 'SET_HANDLER'
export const HANDLERS_CHANGE = prefix + 'HANDLERS_CHANGE'
